import angular from 'angular';

module.exports = angular.module('market.routes.ugc-terms', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('ugc-terms', {
    parent: 'root',
    url: '/ugc-terms',
    template: require('./ugc-terms.jade')(),
    data: {
      meta: {
        titleSuffix: ' | User Generated Content Terms of Use',
        description:
          "Read Opendoor's terms of use for user generated content.",
        keywords: 'Opendoor User Generated Content Terms of Use',
      }
    },
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/ugc-terms.js
 **/